/* eslint-disable import/order */

import * as Textures from './textures';

import { default as DecalCarRoad } from './Decal_CarRoad.json';
import DecalGrassFall from './Decal_Grass_Fall.json';
import DecalGrassSpring from './Decal_Grass_Spring.json';
import DecalGrassSummer from './Decal_Grass_Summer.json';
import DecalGrassWinter from './Decal_Grass_Winter.json';
import DecalGymPattern from './Decal_Gym_Pattern.json';
import DecalParkingPattern from './Decal_Parking_Pattern.json';
import DecalPlayGround from './Decal_PlayGround.json';
import DecalRecycle from './Decal_Recycle.json';
import DecalWalkRoad from './Decal_WalkRoad.json';
import DecalWater from './Decal_Water.json';
export { default as DongFrameTop } from './Dong_Frame_Top.json';
import DongWallFrameL from './Dong_WallFrame_L.json';
import DongWallFrameM from './Dong_WallFrame_M.json';
import DongWallFrameS from './Dong_WallFrame_S.json';
export { default as DongLandFill } from './Dong_LandFill.json';
export { default as DongRoofTop } from './Dong_RoofTop.json';
import DongWindowFrameL from './Dong_WindowFrame_L.json';
import DongWindowFrameM from './Dong_WindowFrame_M.json';
import DongWindowFrameS from './Dong_WindowFrame_S.json';
import DongWindowFrame from './Dong_WindowFrame.json';
import DongWallFrame from './Dong_WallFrame.json';
export { default as DongFXMaterial } from './DongFXMaterial.json';
export { default as FacilityBuilding } from './FacilityBuilding.json';
import FakeWindowView from './FakeWindowView.json';
import GisBuilding from './GIS_Building.json';
import GisMap from './GIS_Map.json';
export { default as ItemFXMaterial } from './ItemFXMaterial.json';
export { default as ParkingEnteranceEntry } from './ParkingEnterance_Entry.json';
export { default as ParkingEnteranceFrame } from './ParkingEnterance_Frame.json';
export { default as ParkingEnteranceGlass } from './ParkingEnterance_Glass.json';
export { default as ParkingEnteranceLetter } from './ParkingEnterance_Letter.json';
import TreeLeaveBushFall from './Tree_Leave_Bush_Fall.json';
import TreeLeaveBushSpring from './Tree_Leave_Bush_Spring.json';
import TreeLeaveBushSummer from './Tree_Leave_Bush_Summer.json';
import TreeLeaveBushWinter from './Tree_Leave_Bush_Winter.json';
import TreeLeaveFlowerFall from './Tree_Leave_Flower_Fall.json';
import TreeLeaveFlowerFallA from './Tree_Leave_Flower_FallA.json';
import TreeLeaveFlowerFallB from './Tree_Leave_Flower_FallB.json';
import TreeLeaveFlowerSpringA from './Tree_Leave_Flower_SpringA.json';
import TreeLeaveFlowerSpringB from './Tree_Leave_Flower_SpringB.json';
import TreeLeaveFlowerSpringC from './Tree_Leave_Flower_SpringC.json';
import TreeLeaveFlowerSpringD from './Tree_Leave_Flower_SpringD.json';
import TreeLeaveFlowerSummerA from './Tree_Leave_Flower_SummerA.json';
import TreeLeaveFlowerSummerB from './Tree_Leave_Flower_SummerB.json';
import TreeLeaveFlowerWinterA from './Tree_Leave_Flower_WinterA.json';
import TreeLeaveFlowerWinterB from './Tree_Leave_Flower_WinterB.json';
import TreeLeaveNormalFall from './Tree_Leave_Normal_Fall.json';
import TreeLeaveNormalSpringA from './Tree_Leave_Normal_SpringA.json';
import TreeLeaveNormalSpringB from './Tree_Leave_Normal_SpringB.json';
import TreeLeaveNormalSpringC from './Tree_Leave_Normal_SpringC.json';
import TreeLeaveNormalSpringD from './Tree_Leave_Normal_SpringD.json';
import TreeLeaveNormalSummer from './Tree_Leave_Normal_Summer.json';
import TreeLeaveNormalWinter from './Tree_Leave_Normal_Winter.json';
export { default as UnitPanelFXMaterial } from './UnitPanelFXMaterial.json';
import UnitWallEdge from './UnitWallEdge.json';
import UnitWallPaper from './UnitWallPaper.json';
import UnitBath from './UnitBath.json';
import UnitBedLargeFrame from './UnitBedLargeFrame.json';
import UnitBedLargeMattress from './UnitBedLargeMattress.json';
import UnitBedSmallFrame from './UnitBedSmallFrame.json';
import UnitBedSmallMattress from './UnitBedSmallMattress.json';
import UnitChestBody from './UnitChestBody.json';
import UnitChestPlate from './UnitChestPlate.json';
import UnitSinkbasin from './UnitSinkbasin.json';
import UnitChair from './UnitChair.json';
import UnitCouch from './UnitCouch.json';
import UnitDoor from './UnitDoor.json';
import UnitFloorBalcony from './UnitFloorBalcony.json';
import UnitFloorBath from './UnitFloorBath.json';
import UnitFloorGate from './UnitFloorGate.json';
import UnitFloorLivingroom from './UnitFloorLivingroom.json';
import UnitFloorRoom from './UnitFloorRoom.json';
import UnitTable from './UnitTable.json';
import UnitToilet from './UnitToilet.json';
import UnitWashbasin from './UnitWashbasin.json';
import UnitWatertap from './UnitWatertap.json';
import UnitWindowGlass from './UnitWindowGlass.json';
import UnitWindowFrame from './UnitWindowFrame.json';
import UnitWindowNewFrame from './UnitWindowNewFrame.json';
import InteriorTourCompass from './InteriorTourCompass.json';
import InteriorTourArrow from './InteriorTourArrow.json';
import Dummy from './Dummy.json';
DecalCarRoad.ambientTexture.name = Textures.DecalGrass_D;

DecalGrassFall.albedoTexture.name = Textures.DecalGrass_D;
DecalGrassFall.ambientTexture.name = Textures.DecalGrass_D;
DecalGrassFall.bumpTexture.name = Textures.DecalGrass_N;
DecalGrassFall.plugins.DetailMapConfiguration.detailTexture.name = Textures.DecalGrass_D;

DecalGrassSpring.albedoTexture.name = Textures.DecalGrass_D;
DecalGrassSpring.ambientTexture.name = Textures.DecalGrass_D;
DecalGrassSpring.bumpTexture.name = Textures.DecalGrass_N;
DecalGrassSpring.plugins.DetailMapConfiguration.detailTexture.name = Textures.DecalGrass_D;

DecalGrassSummer.albedoTexture.name = Textures.DecalGrass_D;
DecalGrassSummer.plugins.DetailMapConfiguration.detailTexture.name = Textures.DecalGrass_D;

DecalGrassWinter.albedoTexture.name = Textures.DecalGrass_D;
DecalGrassWinter.ambientTexture.name = Textures.DecalGrass_D;
DecalGrassWinter.bumpTexture.name = Textures.DecalGrass_N;
DecalGrassWinter.plugins.DetailMapConfiguration.detailTexture.name = Textures.DecalGrass_D;

DecalGymPattern.albedoTexture.name = Textures.DecalGymPattern;

DecalParkingPattern.albedoTexture.name = Textures.DecalParkingPattern_AO;

DecalPlayGround.albedoTexture.name = Textures.DecalPlayGroundPattern;
DecalPlayGround.bumpTexture.name = Textures.DecalGrass_N;

DecalRecycle.albedoTexture.name = Textures.White;
DecalRecycle.ambientTexture.name = Textures.DecalGrass_D;

DecalWalkRoad.albedoTexture.name = Textures.DecalWalkRoad_D;

DecalWater.bumpTexture.name = Textures.DecalWater_N;

DongWallFrameL.albedoTexture.name = Textures.Wall_L_D;
DongWallFrameM.albedoTexture.name = Textures.Wall_M_D;
DongWallFrameS.albedoTexture.name = Textures.Wall_S_D;
DongWallFrame.albedoTexture.name = Textures.Wall_D;

DongWindowFrameL.albedoTexture.name = Textures.DongWindowFrameL_D;
DongWindowFrameL.metallicTexture.name = Textures.DongWindowFrameL_M_CL;
DongWindowFrameL.plugins.PBRClearCoatConfiguration.texture.name = Textures.DongWindowFrameL_M_CL;
DongWindowFrameL.bumpTexture.name = Textures.DongWindowFrameL_N;

DongWindowFrameM.albedoTexture.name = Textures.DongWindowFrameM_D;
DongWindowFrameM.metallicTexture.name = Textures.DongWindowFrameM_M_CL;
DongWindowFrameM.plugins.PBRClearCoatConfiguration.texture.name = Textures.DongWindowFrameM_M_CL;
DongWindowFrameM.bumpTexture.name = Textures.DongWindowFrameM_N;

DongWindowFrameS.albedoTexture.name = Textures.DongWindowFrameS_D;
DongWindowFrameS.metallicTexture.name = Textures.DongWindowFrameS_M_CL;
DongWindowFrameS.plugins.PBRClearCoatConfiguration.texture.name = Textures.DongWindowFrameS_M_CL;
DongWindowFrameS.bumpTexture.name = Textures.DongWindowFrameS_N;

DongWindowFrame.albedoTexture.name = Textures.DongWindowFrame;

UnitWallPaper.albedoTexture.name = Textures.UnitWallPaper;
UnitWallPaper.ambientTexture.name = Textures.UnitWallPaper_AO;

InteriorTourCompass.albedoTexture.name = Textures.InteriorTourCompassBase;
InteriorTourArrow.albedoTexture.name = Textures.InteriorTourArrow;

TreeLeaveBushFall.albedoTexture.name =
  TreeLeaveBushSpring.albedoTexture.name =
  TreeLeaveBushSummer.albedoTexture.name =
  TreeLeaveBushWinter.albedoTexture.name =
  TreeLeaveFlowerFall.albedoTexture.name =
  TreeLeaveFlowerFallA.albedoTexture.name =
  TreeLeaveFlowerFallB.albedoTexture.name =
  TreeLeaveFlowerSpringA.albedoTexture.name =
  TreeLeaveFlowerSpringB.albedoTexture.name =
  TreeLeaveFlowerSpringC.albedoTexture.name =
  TreeLeaveFlowerSpringD.albedoTexture.name =
  TreeLeaveFlowerSummerA.albedoTexture.name =
  TreeLeaveFlowerSummerB.albedoTexture.name =
  TreeLeaveFlowerWinterA.albedoTexture.name =
  TreeLeaveFlowerWinterB.albedoTexture.name =
  TreeLeaveNormalFall.albedoTexture.name =
  TreeLeaveNormalSpringA.albedoTexture.name =
  TreeLeaveNormalSpringB.albedoTexture.name =
  TreeLeaveNormalSpringC.albedoTexture.name =
  TreeLeaveNormalSpringD.albedoTexture.name =
  TreeLeaveNormalSummer.albedoTexture.name =
  TreeLeaveNormalWinter.albedoTexture.name =
    Textures.TreeLeaves_D;

TreeLeaveFlowerSpringA.emissiveTexture.name = TreeLeaveFlowerSpringB.emissiveTexture.name = Textures.TreeFlower_E;
TreeLeaveFlowerSpringC.albedoTexture.name = TreeLeaveFlowerSpringD.albedoTexture.name = Textures.TreeFlower;
TreeLeaveFlowerSpringA.lightmapTexture.name = Textures.TreeFlower_SpringA_L;
TreeLeaveFlowerSpringB.lightmapTexture.name = Textures.TreeFlower_SpringB_L;
TreeLeaveFlowerSpringC.lightmapTexture.name = Textures.TreeFlower_SpringC_L;
TreeLeaveFlowerSpringD.lightmapTexture.name = Textures.TreeFlower_SpringD_L;
TreeLeaveNormalSpringA.lightmapTexture.name = Textures.TreeNormal_SpringA_L;
TreeLeaveNormalSpringB.lightmapTexture.name = Textures.TreeNormal_SpringB_L;
TreeLeaveNormalSpringC.lightmapTexture.name = Textures.TreeNormal_SpringC_L;
TreeLeaveNormalSpringD.lightmapTexture.name = Textures.TreeNormal_SpringD_L;

FakeWindowView.albedoTexture.name = Textures.FakeWindow_D;

UnitFloorRoom.albedoTexture.name = UnitFloorLivingroom.albedoTexture.name = Textures.FloorWood;
UnitFloorRoom.ambientTexture.name = UnitFloorLivingroom.ambientTexture.name = Textures.FloorWood_AO;
UnitFloorRoom.plugins.PBRClearCoatConfiguration.texture.name =
  UnitFloorLivingroom.plugins.PBRClearCoatConfiguration.texture.name = Textures.FloorWood_AO;
UnitFloorRoom.plugins.PBRClearCoatConfiguration.bumpTexture.name =
  UnitFloorLivingroom.plugins.PBRClearCoatConfiguration.bumpTexture.name = Textures.FloorWood_N;
UnitFloorBalcony.albedoTexture.name = Textures.TileBalcony;
UnitFloorBath.albedoTexture.name = Textures.TileBath;
UnitFloorGate.albedoTexture.name = Textures.TileGate;
UnitChestPlate.ambientTexture.name = Textures.TilePlateA;

export {
  DecalCarRoad,
  DecalGrassFall,
  DecalGrassSpring,
  DecalGrassSummer,
  DecalGrassWinter,
  DecalGymPattern,
  DecalParkingPattern,
  DecalPlayGround,
  DecalRecycle,
  DecalWalkRoad,
  DecalWater,
  DongWallFrameL,
  DongWallFrameM,
  DongWallFrameS,
  DongWallFrame,
  DongWindowFrameL,
  DongWindowFrameM,
  DongWindowFrameS,
  DongWindowFrame,
  FakeWindowView,
  GisBuilding,
  GisMap,
  TreeLeaveBushFall,
  TreeLeaveBushSpring,
  TreeLeaveBushSummer,
  TreeLeaveBushWinter,
  TreeLeaveFlowerFall,
  TreeLeaveFlowerFallA,
  TreeLeaveFlowerFallB,
  TreeLeaveFlowerSpringA,
  TreeLeaveFlowerSpringB,
  TreeLeaveFlowerSpringC,
  TreeLeaveFlowerSpringD,
  TreeLeaveFlowerSummerA,
  TreeLeaveFlowerSummerB,
  TreeLeaveFlowerWinterA,
  TreeLeaveFlowerWinterB,
  TreeLeaveNormalFall,
  TreeLeaveNormalSpringA,
  TreeLeaveNormalSpringB,
  TreeLeaveNormalSpringC,
  TreeLeaveNormalSpringD,
  TreeLeaveNormalSummer,
  TreeLeaveNormalWinter,
  UnitWallEdge,
  UnitWallPaper,
  UnitBath,
  UnitBedLargeFrame,
  UnitBedLargeMattress,
  UnitBedSmallFrame,
  UnitBedSmallMattress,
  UnitChestBody,
  UnitChestPlate,
  UnitSinkbasin,
  UnitChair,
  UnitCouch,
  UnitDoor,
  UnitFloorBalcony,
  UnitFloorBath,
  UnitFloorGate,
  UnitFloorLivingroom,
  UnitFloorRoom,
  UnitTable,
  UnitToilet,
  UnitWashbasin,
  UnitWatertap,
  UnitWindowGlass,
  UnitWindowFrame,
  UnitWindowNewFrame,
  InteriorTourCompass,
  InteriorTourArrow,
  Dummy,
};
